module.exports = __webpack_public_path__ + "prod/1.42.2/img/31@2x.0d069d25.png";